import { Helmet } from 'react-helmet';

import { PageProps } from '@/types/PageProps';

import DefaultRouteTabs from '@/components/_common/DefaultRouteTabs';
import { useIntl } from 'react-intl';
import { Tabs } from 'antd';

import SalesInsuranceComparison from '@/components/Charts/SalesInsuranceComparison';
import SalesCostXSale from '@/components/Charts/SalesCostXSale';

const SaleChartsPage = ({ route }: PageProps) => {
  const intl = useIntl();

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <DefaultRouteTabs
        route={route.parent}
        basePath="/app/managementCharts"
        permissions={route.permissions}
      >
        <Tabs defaultActiveKey="insuranceComparison">
          <Tabs.TabPane tab="Comparativo Seguradoras" key="insuranceComparison">
            <SalesInsuranceComparison />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Custo x Venda (Peças)" key="CostXSale">
            <SalesCostXSale />
          </Tabs.TabPane>
        </Tabs>
      </DefaultRouteTabs>
    </>
  );
};

export default SaleChartsPage;
